import { DepositTarget } from '@pages/Traders-Room/Deposit/hooks/types'

import type { FormItemDto } from '@model/WalletPaymentProviderParametersDto'

export const isRealCampaign = (campaign: any): boolean => {
  if (!campaign) return false
  const id = String(campaign.id ?? '').trim()
  const defaultCurrencyId = String(campaign.defaultCurrencyId ?? '').trim()
  const min = Number(campaign.minDepositAmount ?? 0)
  return Boolean(id) && (Boolean(defaultCurrencyId) || min > 0)
}

export const hasTradingAccountCampaign = (values: any): boolean => {
  const ta = values?.tradingAccount
  if (!ta) return false

  if (isRealCampaign(ta.campaign)) return true

  return Array.isArray(ta.campaigns) && ta.campaigns.some((c: any) => isRealCampaign(c))
}

export const shouldAttemptBonusCampaignCheck = (params: {
  target?: DepositTarget
  values: any
}): boolean => {
  const { target, values } = params
  if (target === 'wallet') return true

  return !hasTradingAccountCampaign(values)
}

export const isTokenizedFlowEnabled = (form: FormItemDto[] = []): boolean => {
  const hasTokenizedCardId = form.some((x) => x.field === 'tokenized_card_id')
  const hasIntent = form.some((x) => x.field === 'is_tokenized_card_id_intent')
  return hasTokenizedCardId && hasIntent
}

export const getDepositDestinationId = (params: { target: DepositTarget; values: any }): string => {
  const { target, values } = params
  if (target === 'wallet') return values?.wallet?.id || ''
  return values?.tradingAccount?.wallet?.id || ''
}

export const getDestinationCurrencyId = (params: {
  target?: DepositTarget
  values: any
}): string => {
  const { target, values } = params
  if (target === 'wallet') return values?.wallet?.currency?.id || ''
  return values?.tradingAccount?.currency?.id || values?.tradingAccount?.wallet?.currency?.id || ''
}

export const getBonusDepositAmount = (params: {
  amount?: number
  providerCurrencyId?: string
  destinationCurrencyId?: string
  conversionRate?: number
}): number | undefined => {
  const { amount, providerCurrencyId, destinationCurrencyId, conversionRate } = params
  if (!amount || amount <= 0) return amount

  if (
    providerCurrencyId &&
    destinationCurrencyId &&
    providerCurrencyId !== destinationCurrencyId &&
    typeof conversionRate === 'number' &&
    !Number.isNaN(conversionRate)
  ) {
    const converted = amount * conversionRate
    return Math.round(converted * 100) / 100
  }

  return amount
}
